import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  padding: 12px 18px;
  border-radius: 12px;
  font-weight: ${props => props.variant === 'contained' ? 700 : 600};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 8px;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 120px;

  @media (min-width: 768px) {
    width: auto;
    flex: 1 1 0;
  }

  ${props => {
    if (props.disabled) {
      return `
        background: #1f2937;
        border: ${props.variant === 'outline' ? '1px solid #333' : '0'};
        color: #777;
      `;
    }
    
    if (props.variant === 'outline') {
      return `
        background: #111827;
        border: 1px solid #00f7d2;
        color: #e5e7eb;
      `;
    }
    
    return `
      background: #00f7d2;
      border: 0;
      color: #000;
    `;
  }}
`;

const ActionButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'outline', // 'outline' or 'contained'
  style = {},
  ...props 
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      style={style}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ActionButton;
